var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_16153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16198 10.8854C3.16198 10.8854 3.19957 9.13132 3.23716 8.43587C3.27475 7.74041 3.30633 7.12616 3.67623 5.8984C3.67623 5.8984 4.42807 3.59703 5.3784 1.80915C5.3784 1.80915 5.75432 0.848298 6.31368 0.68515C6.31368 0.68515 7.42867 0.503957 10.5428 0.534781C10.5428 0.534781 13.3141 0.467866 14.1163 0.956563C14.1163 0.956563 14.3629 1.09866 14.7884 2.08056C14.7884 2.08056 15.4861 3.7301 16.2921 4.51126C16.2921 4.51126 17.0274 5.24205 17.3529 5.5894C17.8914 6.15798 18.2868 6.84661 18.5063 7.59831C18.5063 7.59831 19.304 10.0456 19.6964 10.7222C20.0889 11.3989 20.8535 12.4477 20.8535 13.2867C20.8535 14.1258 20.5859 14.6739 19.9972 14.7363C19.4085 14.7987 18.4348 14.1055 17.7875 13.2206C17.2304 12.4582 16.744 11.3665 16.3658 10.3561C16.3267 10.5207 16.2838 10.847 16.2838 11.4838C16.2838 12.6492 16.2335 19.3654 16.2297 19.7706C16.2259 20.1758 16.2883 22.7742 15.8493 23.6215C15.4102 24.4688 15.0019 24.5312 14.6087 24.5312C14.6087 24.5312 13.8163 24.5373 13.4968 23.623C13.1772 22.7088 12.9487 21.8374 12.7855 18.8609C12.7855 18.8609 10.3984 18.9173 9.5045 17.685C9.49672 17.6753 9.48944 17.6653 9.48269 17.6549C9.31202 17.7233 9.02482 17.7895 8.56094 17.7895C8.56094 17.7895 7.49182 17.8354 6.74825 17.1211C6.37835 16.7655 6.18136 16.5001 6.0716 16.2858C5.80873 16.4031 5.51682 16.4393 5.23329 16.3896C4.67543 16.2896 3.8672 16.0137 3.45669 15.0077C3.04619 14.0017 3.16198 11.462 3.16198 10.8854Z",
    fill: "url(#paint0_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M16.5589 9.15969L16.7634 8.29883L17.455 10.1484C17.9062 11.3468 18.3573 12.2618 18.7993 12.8685C19.2159 13.4384 19.7346 13.8497 20.103 14.0339C20.0843 14.0629 20.0594 14.0874 20.0302 14.1059C20.001 14.1243 19.9681 14.1362 19.9339 14.1406L19.9203 14.1406C19.6196 14.1406 18.8497 13.6564 18.2731 12.8678C17.8295 12.261 17.3776 11.346 16.9288 10.1476L16.5589 9.15969Z",
    fill: "url(#paint1_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6542 13.9634L13.1933 10.5342L16.3638 10.3561C16.3247 10.5207 16.2818 10.847 16.2818 11.4838C16.2818 12.6492 16.2314 19.3654 16.2277 19.7706C16.2239 20.1758 16.2863 22.7742 15.8473 23.6215C15.4082 24.4688 15.0022 24.5312 14.609 24.5312C14.609 24.5312 13.8165 24.5373 13.497 23.623C13.1775 22.7088 12.9489 21.8374 12.7858 18.8609C12.7858 18.8609 12.688 15.6174 12.6542 13.9634Z",
    fill: "url(#paint2_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M13.2559 14.0055L13.7115 11.1094L15.6919 10.9981C15.6919 11.0816 15.6859 11.1695 15.6844 11.262L14.3882 11.3372L13.9326 14.231C13.9664 15.8407 14.0581 18.8924 14.0634 19.0624C14.2235 21.9787 14.4453 22.8043 14.7401 23.6486C14.7698 23.7356 14.8116 23.8181 14.8641 23.8937C14.7844 23.9223 14.6997 23.934 14.6153 23.9283C14.5401 23.9238 14.2228 23.8786 14.0634 23.423C13.7679 22.5757 13.5461 21.7502 13.3868 18.8368C13.3815 18.6631 13.2898 15.6137 13.2559 14.0055Z",
    fill: "url(#paint3_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29184 14.5427C9.4174 13.966 9.47154 13.745 9.45048 13.536C10.3068 13.7202 12.6541 13.9615 12.6541 13.9615C12.6879 15.6155 12.7856 18.859 12.7856 18.859C12.7856 18.859 10.3986 18.9154 9.50462 17.6831C9.49684 17.6735 9.48956 17.6634 9.48281 17.653C9.42041 17.5575 9.24222 17.2245 9.24598 16.535C9.25049 15.6998 9.16629 15.1186 9.29184 14.5427Z",
    fill: "url(#paint4_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M9.87614 14.6756L9.90471 14.5441C9.92877 14.432 9.95058 14.332 9.96937 14.2433C10.646 14.3463 11.5121 14.4478 12.061 14.5087C12.0647 14.6591 12.0685 14.8207 12.0723 14.9854C11.5603 14.926 10.9347 14.8478 10.4182 14.7696C10.3994 14.8591 10.3776 14.9591 10.3536 15.0703L10.325 15.2019C10.2543 15.5237 10.2656 15.8786 10.2799 16.3252C10.2866 16.5447 10.2942 16.7943 10.2927 17.0695C10.2887 17.278 10.314 17.486 10.3678 17.6875C10.2228 17.5926 10.0956 17.473 9.99193 17.3341L9.9814 17.3206C9.96411 17.2898 9.84457 17.0605 9.84757 16.5432C9.84757 16.268 9.84156 16.0169 9.83479 15.7989C9.81675 15.3508 9.80547 14.9974 9.87614 14.6756Z",
    fill: "url(#paint5_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20113 13.9624C6.49359 12.8932 6.52667 12.6053 6.54772 12.4128C6.54772 12.4128 8.68521 13.4067 9.45058 13.5368C9.47163 13.7458 9.4175 13.9669 9.29194 14.5435C9.16638 15.1202 9.25059 15.7006 9.24608 16.5359C9.24608 17.2253 9.42051 17.5584 9.48291 17.6539C9.31224 17.7223 9.02504 17.7885 8.56115 17.7885C8.56115 17.7885 7.49204 17.8343 6.74847 17.1201C6.37856 16.7645 6.18158 16.4991 6.07181 16.2848C5.98801 16.117 5.93989 15.9338 5.93047 15.7465C5.9049 15.433 5.90866 15.0322 6.20113 13.9624Z",
    fill: "url(#paint6_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M6.78142 14.1239C6.87841 13.7683 6.94832 13.4939 6.99945 13.2781C7.52574 13.5082 8.23698 13.8044 8.79785 13.9871C8.77981 14.072 8.758 14.1713 8.73319 14.2878L8.72342 14.3344C8.28435 14.1698 7.82121 13.9728 7.44529 13.8081C7.39417 14.0232 7.32424 14.2976 7.22726 14.6532C6.95584 15.6456 6.9566 15.9847 6.97765 16.2216C6.98103 16.3351 7.00871 16.4466 7.05885 16.5486C7.07238 16.5757 7.08817 16.6035 7.10546 16.6328C6.91079 16.4541 6.74426 16.247 6.61151 16.0186C6.56125 15.9167 6.53379 15.8051 6.53105 15.6915C6.51075 15.4554 6.51001 15.1163 6.78142 14.1239Z",
    fill: "url(#paint7_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16213 10.8874C3.16213 10.8874 3.16213 10.8603 3.16213 10.8122C3.68391 11.2505 6.54541 12.4166 6.54541 12.4166C6.52436 12.6091 6.49128 12.8971 6.19881 13.9662C5.90635 15.0353 5.90258 15.4368 5.93115 15.7503C5.94057 15.9376 5.9887 16.1209 6.0725 16.2886C5.80964 16.4059 5.51773 16.4421 5.2342 16.3924C4.67633 16.2924 3.8681 16.0165 3.4576 15.0105C3.04709 14.0045 3.16213 11.4641 3.16213 10.8874Z",
    fill: "url(#paint8_linear_221_16153)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M3.75075 11.8347C4.44996 12.1805 5.32961 12.5572 5.87695 12.7872C5.85891 12.8729 5.83485 12.9752 5.80177 13.0977C5.30104 12.882 4.70108 12.6151 4.19433 12.3647C4.18832 13.3007 4.21464 14.7097 4.46049 15.3104C4.48455 15.3683 4.51011 15.4239 4.53567 15.4766C4.29782 15.2991 4.1153 15.0576 4.00939 14.7804C3.7718 14.1796 3.74473 12.7707 3.75075 11.8347Z",
    fill: "url(#paint9_linear_221_16153)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_221_16153",
    x1: 5.31299,
    y1: 15.2979,
    x2: 19.7483,
    y2: 7.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBA0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FED23F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDDA71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B34100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_221_16153",
    x1: 16.2175,
    y1: 8.56648,
    x2: 19.676,
    y2: 13.9549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_221_16153",
    x1: 12.3858,
    y1: 14.2799,
    x2: 18.3253,
    y2: 20.8209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBA0B",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C45D03",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B34100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_221_16153",
    x1: 14.2882,
    y1: 11.5808,
    x2: 15.2408,
    y2: 24.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_221_16153",
    x1: 10.7512,
    y1: 15.1629,
    x2: 12.3887,
    y2: 18.5207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBA0B",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C45D03",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B34100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_221_16153",
    x1: 10.8453,
    y1: 14.4711,
    x2: 11.1295,
    y2: 17.4785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_221_16153",
    x1: 7.39129,
    y1: 14.0902,
    x2: 8.94534,
    y2: 17.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBA0B",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C45D03",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B34100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_221_16153",
    x1: 7.61521,
    y1: 14.0172,
    x2: 7.74903,
    y2: 16.2561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_221_16153",
    x1: 4.70491,
    y1: 12.8354,
    x2: 5.80785,
    y2: 16.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBA0B",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#C45D03",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B34100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_221_16153",
    x1: 4.6898,
    y1: 12.6684,
    x2: 5.3251,
    y2: 15.5751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_16153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.53125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerArrowDown);
export default __webpack_public_path__ + "static/media/finger-arrow-down.eb474a8502fd9ba09676ada535ae924b.svg";
export { ForwardRef as ReactComponent };